import * as CM                from '@emersya/mpa-components-manager';

export interface ITableColumnComponentConfiguration extends CM.Component.IConfiguration {
	typeValue? : string;
	typeConfiguration : CM.DOMComponent.IConfiguration;
	// isEditable?       : boolean;
};

export class TableColumnComponent extends CM.Component<
	TableColumnComponent,
	ITableColumnComponentConfiguration
>
{
	typeValue : typeof CM.DOMComponent;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : ITableColumnComponentConfiguration
	)
	{
		super(descriptor, configuration);
		if (!this.component_configuration.typeValue) {
			this.component_configuration.typeValue = 'input-text';
		}
		this.typeValue = <typeof CM.DOMComponent> <any> CM.Manager.getClassProxyOrThrow(this.component_configuration.typeValue);
		// if (this.configuration.isEditable === undefined) {
		// 	this.configuration.isEditable = true;
		// }
	};
};
export namespace NS {
	export const Component = TableColumnComponent;
	export type Component = TableColumnComponent;
	export type Configuration = ITableColumnComponentConfiguration;
}
;
import manifestXMLSource from './TableColumn.xml';
import './TableColumn.scss';

CM.Manager.declare({
	id :       'tableColumn',
	type :     TableColumnComponent,
	manifest : manifestXMLSource
});
